export enum WaitingTime {
  DEFAULT = 20,
  AIRPORT = 60,
}
